var SavedEmailStatusEnum;
(function (SavedEmailStatusEnum) {
    SavedEmailStatusEnum["NONE"] = "none";
    SavedEmailStatusEnum["SUCCESS"] = "success";
    SavedEmailStatusEnum["ERROR"] = "failed";
})(SavedEmailStatusEnum || (SavedEmailStatusEnum = {}));
export default SavedEmailStatusEnum;
